import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { previewKind, fileAccessUrl, formatSize, formatDate } from '@/components/library/libraryMeta';
import { DownloadButton } from '@/components/library/ItemCard';

const Viewer = ({ kind, src, title }) => {
  if (!src) return <Loader2 className="w-7 h-7 animate-spin text-cyan-400" data-testid="preview-loading" />;
  if (kind === 'pdf') return <iframe title={title} src={src} className="w-full h-full border-0 bg-white" data-testid="preview-pdf" />;
  if (kind === 'image') return <img src={src} alt={title} className="max-w-full max-h-full object-contain" data-testid="preview-image" />;
  return <video src={src} controls className="max-w-full max-h-full" data-testid="preview-video" />;
};

export const PreviewDialog = ({ item, onOpenChange }) => {
  const [src, setSrc] = useState('');
  useEffect(() => {
    setSrc('');
    if (!item) return undefined;
    let live = true;
    fileAccessUrl(item).then((url) => live && setSrc(url)).catch(() => toast.error('Could not open file'));
    return () => { live = false; };
  }, [item]);

  if (!item) return null;
  return (
    <Dialog open={!!item} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[hsl(var(--card))] border-[hsl(var(--border))] max-w-5xl w-[95vw] p-0 gap-0 overflow-hidden" data-testid="preview-dialog">
        <DialogHeader className="flex-row items-center justify-between gap-3 space-y-0 px-5 py-3 pr-12 border-b border-[hsl(var(--border))]">
          <div className="min-w-0">
            <DialogTitle className="text-sm truncate" data-testid="preview-title">{item.title}</DialogTitle>
            <DialogDescription className="text-[11px] truncate">
              {item.original_filename} · {formatSize(item.size)} · {item.user_name} · {formatDate(item.created_at)}
            </DialogDescription>
          </div>
          <DownloadButton item={item} testId="preview-download-btn" size={14} className="shrink-0 h-8" />
        </DialogHeader>
        <div className="bg-black/40 h-[75vh] flex items-center justify-center" data-testid="preview-body">
          <Viewer kind={previewKind(item)} src={src} title={item.title} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
